export const QUICK_SUMMARY_FEEDBACK_ENTRYPOINT_ID = 'd44ea02e-f7d1-491c-b061-53405badbbd3';
